import { buildIconAndTextRow } from "../../base/components/ProjectWidget";
import { aboutMeText, userData } from "../../base/data/userData";

import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { ConvertMdFile } from "../../base/utils/convertMdFile";

export const AboutMeWidget = () => {
  return (
    <div className="markdown">
      <ConvertMdFile mdFile={aboutMeText} />
      <div className="flex flex-col">
        <h3>Contact Me</h3>
        <a
          href={`mailto: ${userData.email}`}
          target={"_blank"}
          rel="noreferrer"
        >
          {buildIconAndTextRow(
            "",
            "Email",
            faEnvelope,
            false,
            "text-gray-900",
            userData.email
          )}
        </a>
        <a href={userData.github} target={"_blank"} rel="noreferrer">
          {buildIconAndTextRow(
            "",
            "Github Profile",
            faGithub,
            false,
            "text-gray-900",
            userData.github
          )}
        </a>
       {userData.linkedin && <a href={userData.linkedin} target={"_blank"} rel="noreferrer">
          {buildIconAndTextRow(
            "",
            "Linkedin Profile",
            faLinkedin,
            false,
            "text-blue-900",
            userData.linkedin
          )}
        </a>}

       
      </div>
    </div>
  );
};

export const AboutMeView = () => {
  const title = "About Me";
  return (
    <div className="inline-flex flex-col gap-5 text-justify w-full">
      <div>
        <h3>{title}</h3>
        <hr className="border-t border-black" />
        <AboutMeWidget />
      </div>
    </div>
  );
};
